import styled from 'styled-components';

export const HIWCardContainer = styled.div`
    margin: 4% 10%;
`;

export const HIWTitle = styled.h2``;

export const HIWDescription = styled.p`
    text-align: justify;
    margin-top: 10px;
    line-height: 1.5;
`;